import {Injectable} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
export class ValidationErrorService {
constructor() {
  }
/**
 * This is used to compose validation messages
 * @param {?} validationObj
 * @param {?=} message
 * @return {?}
 */
public message(validationObj, message?: SafeHtml | string) {
    let /** @type {?} */ msg = ``;
    if (validationObj && validationObj.constructor === Object) {
      msg = this.processObj(validationObj);
    } else if (validationObj && validationObj.constructor === Array) {
      msg = this.processArray(validationObj);
    }
    return (msg) ? msg : message;
  }
/**
 * @param {?} data
 * @return {?}
 */
private processObj(data) {
    let /** @type {?} */ msg = ``;
    Object.keys(data).forEach((key) => {
      if (data[key] && data[key].constructor === String) {
        msg += `${data[key]}. <br>`;
      } else if (data[key] && data[key].constructor === Object) {
        msg += this.processObj(key);
      } else if (data[key] && data[key].constructor === Array) {
        msg += this.processArray(data[key]);
      }
    });
    return msg;
  }
/**
 * @param {?} dataObj
 * @return {?}
 */
private processArray(dataObj) {
    let /** @type {?} */ msg = ``;
    dataObj.forEach((data) => {
      if (data && data.constructor === String) {
        msg += `${data}. <br>`;
      } else if (data && data.constructor === Object) {
        msg += this.processObj(data);
      } else if (data && data.constructor === Array) {
        msg += this.processArray(data);
      }
    });
    return msg;
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ValidationErrorService_tsickle_Closure_declarations() {
/** @type {?} */
ValidationErrorService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ValidationErrorService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
